import { render, staticRenderFns } from "./selectAsset.vue?vue&type=template&id=a867ec08&"
import script from "./selectAsset.vue?vue&type=script&lang=js&"
export * from "./selectAsset.vue?vue&type=script&lang=js&"
import style0 from "./selectAsset.vue?vue&type=style&index=0&id=a867ec08&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports